(() => {
  'use strict';
  const instances = new WeakMap();
  function initGallery(gallery) {
  if (instances.has(gallery)) return;
  const lifecycle = new AbortController();
  instances.set(gallery, lifecycle);
  const on = (target, type, handler) => target.addEventListener(type, handler, { signal: lifecycle.signal });
  let config = {};
  try { config = JSON.parse(gallery.querySelector('[data-gallery-config]')?.textContent || '{}'); } catch {}
  const $ = selector => gallery.querySelector(selector);
  const $$ = selector => [...gallery.querySelectorAll(selector)];
  const model = $('.purchase-heat-product');
  const stage = $('.gallery-stage');
  const rotation = $('.rotation-view');
  const rotationImage = $('.rotation-image');
  const range = $('#rotation-range');
  const status = $('.gallery-load-status');
  const frames = config.frames || [
    ['vest-front-straight.png', 'front view', 101.377, 50.089, 49.108],
    ['vest-front-cutout.png', 'front left three-quarter view', 105.54, 49.688, 47.825],
    ['vest-angle-090.png', 'left side view', 99.177, 50.134, 48.645],
    ['vest-angle-135.png', 'rear left three-quarter view', 99.9, 52.184, 49.251],
    ['vest-back-cutout.png', 'back view', 105.721, 49.688, 47.896],
    ['vest-angle-225.png', 'rear right three-quarter view', 98.471, 50.653, 48.773],
    ['vest-angle-270.png', 'right side view', 98.321, 51.353, 49.523],
    ['vest-angle-315.png', 'front right three-quarter view', 99.577, 50.357, 49.322]
  ];
  const details = config.details || {
    collar: { number: '01', title: 'Comfort, up close.', description: 'A closer look at the padded stand collar, central zip and quilted finish.', alt: 'Angled close-up of the black padded collar and central zipper' },
    control: { number: '02', title: 'One touch. Your warmth.', description: 'The chest-mounted button puts your three heat settings within easy reach.', alt: 'Close-up of the square power button and quilted chest fabric' },
    pocket: { number: '03', title: 'Every last detail.', description: 'Explore the pocket zip, angled quilting and clean finish around the hem.', alt: 'Side-angle close-up of the pocket zipper, quilting and hem' }
  };
  let mode = 'heat', side = 'back', heatOn = true, frame = 0, displayedFrame = 0, detail = 'collar';
  let request = 0, drag = null, zoomFocus;
  const loaded = new Map();
  let color = gallery.closest('.product-section').dataset.selectedColor || 'Black';
  function applyColor(nextColor) {
    color = config.colors?.[nextColor] ? nextColor : 'Black';
    const images = config.colors?.[color];
    if (!images) return;
    ['front','back'].forEach(view => {
      const image = model.querySelector(`.${view}-photo`);
      image.src = images[view];
      image.alt = `${color} quilted heated vest, ${view} view — original AI-created product visualization`;
      model.style.setProperty(`--${view}-mask`, `url("${images[view]}")`);
    });
    setMode('heat');
  }
  function loadFrame(index) {
    if (!loaded.has(index)) {
      loaded.set(index, new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => { loaded.delete(index); reject(new Error('Image could not load')); };
        image.src = config.frames ? frames[index][0] : `assets/${frames[index][0]}`;
      }));
    }
    return loaded.get(index);
  }
  function updateHeat() {
    model.dataset.side = side;
    model.dataset.heat = heatOn ? 'on' : 'off';
    model.querySelector('.front-photo').setAttribute('aria-hidden', String(side !== 'front'));
    model.querySelector('.back-photo').setAttribute('aria-hidden', String(side !== 'back'));
    $$('[data-purchase-side]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.purchaseSide === side)));
    $('.purchase-heat-toggle').setAttribute('aria-pressed', String(heatOn));
    $('.purchase-heat-toggle span').textContent = heatOn ? 'Heat on' : 'Heat off';
    if (mode === 'heat') {
      $('[data-gallery-state]').textContent = heatOn ? (side === 'front' ? 'SEE-THROUGH HEAT PREVIEW' : 'WARMTH, MADE VISIBLE') : 'THE EVERYDAY ESSENTIAL';
      $('[data-gallery-note]').textContent = `${color.toUpperCase()} / ` + (heatOn ? (side === 'front' ? 'REAR NECK + BACK HEATING · SHOWN THROUGH FABRIC' : 'NECK + BACK') : `${side.toUpperCase()} VIEW · HEAT OFF`);
    }
  }
  async function showFrame(index) {
    frame = (index + frames.length) % frames.length;
    const next = frame, ownRequest = ++request;
    try {
      await loadFrame(next);
      if (ownRequest !== request) return;
      const [file, description, height, x, y] = frames[next];
      rotationImage.src = config.frames ? file : `assets/${file}`;
      rotationImage.alt = `Black quilted vest, ${description}`;
      rotationImage.style.height = `${height}%`;
      rotationImage.style.transform = `translate(-${x}%,-${y}%)`;
      displayedFrame = next;
      range.value = next;
      range.setAttribute('aria-valuetext', `${next * 45} degrees, ${description}`);
      $('.rotation-angle').textContent = `${String(next * 45).padStart(3, '0')}°`;
      status.hidden = true;
    } catch {
      if (ownRequest !== request || mode !== 'rotate') return;
      frame = displayedFrame;
      range.value = displayedFrame;
      status.textContent = 'This angle could not load. Please try rotating again.';
      status.hidden = false;
    }
  }
  function setMode(next) {
    mode = next;
    stage.dataset.mode = mode;
    $('.purchase-heat-view').hidden = mode !== 'heat';
    $('.purchase-heat-controls').hidden = mode !== 'heat';
    rotation.hidden = mode !== 'rotate';
    $('.rotation-controls').hidden = mode !== 'rotate';
    $('.gallery-detail-view').hidden = mode !== 'detail';
    $('.gallery-detail-description').hidden = mode !== 'detail';
    status.hidden = true;
    $$('[data-gallery-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryMode === mode)));
    $$('[data-gallery-detail]').forEach(button => button.setAttribute('aria-pressed', String(mode === 'detail' && button.dataset.galleryDetail === detail)));
    if (mode === 'heat') updateHeat();
    if (mode === 'rotate') {
      $('[data-gallery-state]').textContent = 'EVERY ANGLE. ALL AROUND.';
      $('[data-gallery-note]').textContent = 'BLACK / DRAG TO ROTATE ↔';
      showFrame(frame);
      frames.forEach((_, index) => loadFrame(index).catch(() => {}));
    }
    if (mode === 'detail') {
      const selected = details[detail];
      const image = $('.gallery-detail-view>img');
      image.src = selected.src || `assets/vest-detail-${detail}.png`;
      image.alt = selected.alt;
      $('[data-gallery-state]').textContent = 'CONSIDERED, DOWN TO THE DETAIL';
      $('[data-detail-number]').textContent = `${selected.number} / UP CLOSE`;
      $('[data-detail-title]').textContent = selected.title;
      $('.gallery-detail-description').textContent = selected.description;
      $('[data-gallery-note]').textContent = 'BLACK / STUDIO DETAIL';
    }
  }
  // View direction and heating are independent. The front shows a labeled
  // see-through projection of the same rear elements, never extra heaters.
  $$('[data-gallery-mode]').forEach(button => on(button, 'click', () => {
    if (button.dataset.galleryMode === 'heat') heatOn = true;
    setMode(button.dataset.galleryMode);
  }));
  $$('[data-purchase-side]').forEach(button => on(button, 'click', () => {
    side = button.dataset.purchaseSide;
    updateHeat();
  }));
  on($('.purchase-heat-toggle'), 'click', () => {
    heatOn = !heatOn;
    updateHeat();
  });
  $$('[data-gallery-detail]').forEach(button => on(button, 'click', () => {
    detail = button.dataset.galleryDetail;
    setMode('detail');
    if (stage.getBoundingClientRect().top < 90) {
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.dataset.motion === 'off';
      stage.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'instant' : 'smooth' });
    }
  }));
  $$('[data-rotate-step]').forEach(button => on(button, 'click', () => showFrame(frame + Number(button.dataset.rotateStep))));
  on(range, 'input', () => showFrame(Number(range.value)));
  on(rotation, 'pointerdown', event => {
    if (event.button !== 0) return;
    drag = { id: event.pointerId, x: event.clientX, y: event.clientY, start: frame, active: false };
  });
  on(rotation, 'pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.active) {
      if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
      if (Math.abs(dx) < 8) return;
      drag.active = true;
      rotation.setPointerCapture(event.pointerId);
      rotation.classList.add('is-dragging');
    }
    const count = frames.length;
    const next = ((drag.start + Math.round(dx / 34)) % count + count) % count;
    if (next !== frame) showFrame(next);
  });
  function endDrag() {
    if (drag && rotation.hasPointerCapture(drag.id)) rotation.releasePointerCapture(drag.id);
    drag = null;
    rotation.classList.remove('is-dragging');
  }
  ['pointerup','pointercancel','lostpointercapture'].forEach(type => on(rotation, type, endDrag));
  const dialog = document.querySelector('#image-dialog');
  on($('.gallery-zoom'), 'click', () => {
    const body = dialog.querySelector('.gallery-zoom-body');
    body.replaceChildren();
    if (mode === 'heat') {
      const clone = model.cloneNode(true);
      clone.innerHTML = clone.innerHTML.replaceAll('warmth-field-3', 'warmth-field-zoom');
      body.append(clone);
    } else if (mode === 'rotate') {
      const wrap = document.createElement('div');
      wrap.className = 'zoom-rotation';
      wrap.append(rotationImage.cloneNode(true));
      body.append(wrap);
    } else {
      body.append($('.gallery-detail-view>img').cloneNode(true));
    }
    zoomFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('modal-open');
  });
  on(dialog, 'close', () => zoomFocus?.isConnected && zoomFocus.focus());
  on(gallery, 'shopify:block:select', event => {
    const selected = event.target.closest('[data-gallery-detail]');
    if (selected) { detail = selected.dataset.galleryDetail; setMode('detail'); }
  });
  on(gallery.closest('.product-section'), 'ororo:variant-change', event => applyColor(event.detail.color));
  applyColor(color);
  updateHeat();
  }
  const init = root => root.querySelectorAll('.product-gallery').forEach(initGallery);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.product-gallery').forEach(gallery => {
      instances.get(gallery)?.abort();
      instances.delete(gallery);
    });
    const dialog = document.querySelector('#image-dialog');
    if (dialog?.open) dialog.close();
  });
})();
